import DotLoader from "../../../common/core-ui/DotLoader.tsx";
import styles from "./AssetActivator.module.scss";
import { useEffect } from "react";
import { useActivateLoaderData } from "./activateLoader.ts";
import { useAssetActivateFetcher } from "../actions/explore/activate/activate.ts";
import {
  useHomeContextIsExploreReady,
  useHomeContextUser,
} from "../homeContext.ts";
import { getBestCreditForAsset } from "../actions/explore/activate/utils.ts";
import { getReaderURL, getSystemErrorURL } from "../../bookshelfLinks.ts";
import { useCurrentFullLocale } from "../../../common/utils/locale.ts";
import { useLocation, useParams } from "react-router-dom";

export default function AssetActivator() {
  const asset = useActivateLoaderData();
  const user = useHomeContextUser();
  const isExploreReady = useHomeContextIsExploreReady();
  const fetcher = useAssetActivateFetcher();
  const locale = useCurrentFullLocale();
  const params = useParams();
  const deepLink = params["*"] ? "/" + params["*"] : "";
  const location = useLocation();

  useEffect(() => {
    if (isExploreReady && fetcher.state === "idle" && !fetcher.data) {
      fetcher.submit(
        { credit: getBestCreditForAsset(user, asset).id },
        { action: `/actions/activate/${asset.vbid}`, method: "POST" }
      );
    }
  }, [asset, fetcher, user, isExploreReady]);

  useEffect(() => {
    if (fetcher.data) {
      if (fetcher.data.ok) {
        window.location.replace(
          getReaderURL(asset.vbid) + deepLink + location.search
        );
      } else {
        window.location.replace(getSystemErrorURL({ locale }));
      }
    }
  }, [fetcher, asset, locale, deepLink, location.search]);

  return (
    <div className={styles.loadingContainer}>
      <DotLoader />
    </div>
  );
}
